import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cellLabel: {
    color: '#000',
  },
  cell: {
    height: 40,
  },
  sortLabel: {
    position: 'relative',
    justifyContent: 'center',
  },
  sortIcon: {
    position: 'absolute',
    right: -20,
  },
}));

export default useStyles;
